import { Layout, theme, Button, Radio, Divider, List, Empty, Tooltip, message } from "antd";
import React, { useState, useRef, useEffect } from "react";
import { ReloadOutlined, FilterOutlined, FullscreenOutlined, InfoCircleOutlined, DownloadOutlined } from "@ant-design/icons";
import SideNavBar from "../../Components/SideBar/Sidebar";
import AutoCrawling from "../../Components/AutoCrawling/AutoCrawling";
import "../Timecards/Timecards.css";
import UploadFile from "../../Components/Upload/UploadFile";
import Table from "../../Components/Table/Table";
import Cookies from "js-cookie";
import { Redirect, Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Navbar from "../../Components/Support/Header";
import axios from "axios";
import * as XLSX from "xlsx";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { Card, Row, Col } from "antd";
import InvalidClientsCard from "../../Components/AutoCrawling/InvalidClientsCard";
import { useDispatch, useSelector } from "react-redux";
import { Get_DV_ConsolidatedReport } from "../../redux/TimeCardsRedux/TimeCardsActions";
import UnmatchedList from "../../Components/UnmatchedList/UnmatchedList";

const { Meta } = Card;

const { Header, Content } = Layout;

const Timecards = () => {
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const [isloading, setloading] = useState(false);
  const [biweeklyLoader, setBiweeklyLoader] = useState(false)
  const [isloadingconsolidate, setloadingconsolidate] = useState(false);
  const [DataValidationHours, setDataValidationHours] = useState({});
  const [endDate, setStartDate] = useState(new Date());
  const [isloadingUnmatchedlist, setloadingUnmatchedlist] = useState(false);



  const dispatch = useDispatch();

  const newEnddate =
    parseInt(endDate.getMonth() + 1) +
    "/" +
    endDate.getDate() +
    "/" +
    endDate.getFullYear();

  const handleConsolidate = async () => {
    setloadingconsolidate(true);
    try {
      const response = await axios(
        `${process.env.REACT_APP_BASE_URL}ConsolidationReports/GetPayrollMasterDump`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      let tempData = response.data;
      // console.log(response.data)
      handleList(tempData);
    } catch (error) {
      setloadingconsolidate(false);
      console.log(error);
    }
  };
  // const currentDate = new Date()
  const handleList = (props) => {
    let sampleList = props;
    let loopedList = [];
    loopedList.length = 0;
    let len = sampleList.length;
    let i;
    for (i = 0; i < len; i++) {
      const currentDate = new Date(sampleList[i].weekend)
      var dateNew = parseInt(currentDate.getMonth() + 1) + '/' + parseInt(currentDate.getDate()) + '/' + parseInt(currentDate.getFullYear())
      const downDate = new Date(sampleList[i].downloadDate)
      var downloadDates = parseInt(downDate.getMonth() + 1) + '/'
        + parseInt(downDate.getDate()) + '/' + parseInt(downDate.getFullYear())
      const floatRT = parseFloat(sampleList[i].rt)
      const floatOT = parseFloat(sampleList[i].ot)
      const floatDT = parseFloat(sampleList[i].dt)
      const floatOtherHours = parseFloat(sampleList[i].other_Hours)
      loopedList.push({
        // id: i+1,
        Client_Type: sampleList[i].client_Type,
        Client: sampleList[i].client,
        Payroll_Name: sampleList[i].payroll_Name,
        Weekend: dateNew,
        RT: floatRT,
        OT: floatOT,
        DT: floatDT,
        Status: sampleList[i].status,
        Other_Hours: floatOtherHours,
        DownloadDate: downloadDates,
        UserName: sampleList[i].userName,
      });
    }
    setloadingconsolidate(false);
    // console.log((loopedList[0].rt))
    handleOnExport(loopedList);
  };

  const handleOnExport = (props) => {
    const listData = props;
    // console.log(listData)
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(listData);

    XLSX.utils.book_append_sheet(wb, ws, "Myfile");

    XLSX.writeFile(wb, "ConsolidateReport.xlsx");
  };
  const handleUnMatchedNames = async () => {
    setloadingUnmatchedlist(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}Paychex/GetUnmatchedNames`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      let resdata = res.data;
      console.log(resdata)
      handleUnmatchedList(resdata)
    } catch (err) {
      setloadingUnmatchedlist(false);
      message.error("unable to download file")
    }
  };

  const handleUnmatchedList = (props) => {
    let sampleList = props;
    let loopedList = [];
    loopedList.length = 0;
    let len = sampleList.length;
    let i;
    for (i = 0; i < len; i++) {

      loopedList.push({
        // id: i+1,
        FileNumber: sampleList[i].filenumber,
        PortalName: sampleList[i].portalname,
        ClientName: sampleList[i].clientname,
      });
    }
    setloadingUnmatchedlist(false);
    // console.log((loopedList[0].rt))
    handleOnUnmatchExport(loopedList);
  };

  const handleOnUnmatchExport = (props) => {
    const listData = props;
    // console.log(listData)
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(listData);

    XLSX.utils.book_append_sheet(wb, ws, "Myfile");

    XLSX.writeFile(wb, "UnmatchedList.xlsx");
  };
  const handleReview = async (props) => {
    let value = props;
    if (value === "weekly") {
      setloading(true);
    }
    else {
      setBiweeklyLoader(true)
    }
    try {
      let url;
      if (value === "weekly") {
        url = `${process.env.REACT_APP_BASE_URL}Paychex/Get_PayChexMasterFileData_Weekly`
      }
      else {
        url = `${process.env.REACT_APP_BASE_URL}Paychex/Get_PayChexMasterFileData_BiWeekly`
      }
      const res = await axios.get(
        url,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      let tempdata = res.data;
      handlePcxData(tempdata, value);
    } catch (err) {
      setloading(false);
      setBiweeklyLoader(false)
    }
  };
  const handlePcxData = (props, frequency) => {
    let tempList = props;
    let value = frequency;
    let loopList = []
    loopList.length = 0;
    let len = tempList.length;
    loopList.push(['Comp_Code', 'FileNumber', 'Paychex_Employee_Name', 'Portal_Employee_Name', 'State',
      'Client', 'Hire_Date', 'Rate_Type', 'Pay_Rate', 'Pay_Frequency', ' Flsa',
      'Term_Date', 'Employee_Status', 'Period', 'Temp_Rate', 'RT_Week_1',
      'OT_Week_1', 'DT_Week_1', 'Status_W', 'RT_Week_2', 'OT_Week_2', 'DT_Week_2',
      'Status_B', 'RT_Total', 'OT_Total', 'DT_Total', 'Salary_Amount',
      'Holiday_Hours', 'PTO_Hours', 'Sick_Hours', 'Covid_Hours', 'Training_Hours',
      'Gym_Amount', 'Fmla_Amount', 'Sevpay_Amount', 'Bonus_Amount', 'Missing_in_Paychex_list',
      'Insert_Date', 'Paydate', 'Ticket_Number', 'Remarks'
    ])
    for (let i = 0; i < len; i++) {
      const hrdt = new Date(tempList[i].hire_date)
      var newHiredt = parseInt(hrdt.getMonth() + 1) + '/' + parseInt(hrdt.getDate()) + '/' + parseInt(hrdt.getFullYear());
      let trmdt;
      var newTermdt;
      if (tempList[i].term_date !== null) {
        trmdt = new Date(tempList[i].term_date);
        newTermdt = parseInt(trmdt.getMonth() + 1) + '/' + parseInt(trmdt.getDate()) + '/' + ('0' + '0' + '0' + '0' + parseInt(trmdt.getFullYear())).slice(-4);
      }
      const pydt = new Date(tempList[i].payDate)
      var newPaydt = parseInt(pydt.getMonth() + 1) + '/' + parseInt(pydt.getDate()) + '/' + parseInt(pydt.getFullYear());
      let floatRT_Week1;
      if (tempList[i].rt_wk1 !== null) {
        if (tempList[i].rt_wk1 !== "") {
          floatRT_Week1 = parseFloat(tempList[i].rt_wk1)
        }
      }
      let floatOT_Week1;
      if (tempList[i].ot_wk1 !== null) {
        if (tempList[i].ot_wk1 !== "") {
          floatOT_Week1 = parseFloat(tempList[i].ot_wk1)
        }
      }
      let floatRT_Week2;
      if (tempList[i].rt_wk2 !== null) {
        if (tempList[i].rt_wk2 !== "") {
          floatRT_Week2 = parseFloat(tempList[i].rt_wk2)
        }
      }
      let floatOT_Week2;
      if (tempList[i].ot_wk2 !== null) {
        if (tempList[i].ot_wk2 !== "") {
          floatOT_Week2 = parseFloat(tempList[i].ot_wk2)
        }
      }
      loopList.push([
        // tempList[i].id,
        tempList[i].comp_code,
        tempList[i].file_number,
        tempList[i].pcx_emp_name,
        tempList[i].portal_emp_name,
        tempList[i].state,
        tempList[i].client,
        newHiredt,
        tempList[i].rate_type,
        tempList[i].pay_rate,
        tempList[i].pay_frequency,
        tempList[i].flsa,
        newTermdt,
        tempList[i].emp_status,
        tempList[i].period,
        tempList[i].temp_rate,
        //  tempList[i].rt_wk1,
        floatRT_Week1,
        // tempList[i].ot_wk1,
        floatOT_Week1,
        tempList[i].dt_wk1,
        tempList[i].status_W,
        // tempList[i].rt_wk2,
        floatRT_Week2,
        floatOT_Week2,
        // tempList[i].ot_wk2,
        tempList[i].dt_wk2,
        tempList[i].status_B,
        tempList[i].rt_total,
        tempList[i].ot_total,
        tempList[i].dt_total,
        tempList[i].sal_amnt,
        tempList[i].holiday_hrs,
        tempList[i].pto_hrs,
        tempList[i].sick_hrs,
        tempList[i].covid_hrs,
        tempList[i].training_hrs,
        tempList[i].gym_amnt,
        tempList[i].fmla_amnt,
        tempList[i].sevpay_amnt,
        tempList[i].bonus_amnt,
        tempList[i].missingInPaychexList,
        tempList[i].insertDate,
        newPaydt,
        tempList[i].ticket_Number,
        tempList[i].remarks
      ])
    }
    handlePaychexExport(loopList);
    if (value === "weekly") {
      setloading(false);
    }
    else {
      setBiweeklyLoader(false)
    }
  }
  const handlePaychexExport = async (props) => {
    const payData = props;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    // Define cell styles

    // Populate data rows
    for (let i = 0; i < payData.length; i++) {
      worksheet.addRow(payData[i]);
      if (payData[i][40] !== null && i !== 0) {
        // console.log(payData[i])
        worksheet.getRow(i + 1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFA500" },
        };
      }
      // if (payData[i][10] === 'N' && (payData[i][15] > 40 || payData[i][19] > 40)) {
      //   // console.log(payData[i])
      //   worksheet.getRow(i + 1).fill = {
      //     type: "pattern",
      //     pattern: "solid",
      //     fgColor: { argb: "FF0000" },
      //   };
      // }
      // else if (payData[i][10] === 'E' && (payData[i][16] > 0 || payData[i][20] > 0)) {
      //   // console.log(payData[i])
      //   worksheet.getRow(i + 1).fill = {
      //     type: "pattern",
      //     pattern: "solid",
      //     fgColor: { argb: "FF0000" },
      //   };
      // }
      // else if (payData[i][4] === 'CA' && ((payData[i][15] < 40 && payData[i][16] > 0) || (payData[i][19] < 40 && payData[i][20] > 0))) {
      //   // console.log(payData[i])
      //   worksheet.getRow(i + 1).fill = {
      //     type: "pattern",
      //     pattern: "solid",
      //     fgColor: { argb: "FFA500" },
      //   };
      // }
    }
    return workbook.xlsx.writeBuffer()
      .then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, 'PaychexReport.xlsx');
      });
  };

  useEffect(() => {
    const GetDataValidationData = async () => {
      const url = `${process.env.REACT_APP_BASE_URL}DashBoard/hours-data`;
      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      };
      const response = await axios.get(url, config);
      setDataValidationHours(response.data);
      // console.log(response.data)
    };
    GetDataValidationData();
  }, []);


  const loader = (flag) => (

    <div>
      <div className="review-loader">
        <div>
          <ClipLoader
            color={"#3A7783"}
            loading={flag}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
          ></ClipLoader>
        </div>
      </div>
    </div>

  )

  //Get AutoCrawl Status
  const AutoCrawl = useSelector((state) => state.timecardsReducer);

  //Get ReConsolidation Clients List
  const ReConsolidation_Clients_State = useSelector((state) => state.rcClientsReducer);

  if (jwtToken === undefined) {
    return <Redirect to="/" />;
  }
  return (
    <div className="timecards-container">
      <Layout className="timecards-layout-container">
        <SideNavBar />
        <Layout className="timecards-sub-layout-container">
          <Header className="timecards-header">
            <Navbar />
          </Header>
          <div
            className="timecards-block"
          >
            {/* main section */}
            <div style={{ width: AutoCrawl.invalidClients.length === 0 ? "100%" : "78%" }} className="Main-Section" >
              <Row>
                <Col span={24}>
                  <div>
                    <AutoCrawling />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Card className="card-with-divider">
                      <Row>
                        <Col className="left-section">
                          <div>
                            <div className="missing-emp">
                              <p style={{ marginRight: "15px" }}>
                                Missing Employees
                              </p>
                              <p>905</p>
                            </div>
                            <div className="missing-emp">
                              <p style={{ marginRight: "15px" }}>New Clients</p>
                              <p>59</p>
                            </div>
                          </div>
                        </Col>
                        <div className="divider"></div>
                        <Col className="right-section">
                          <div style={{ margin: "auto" }}>
                            <div className="rt_ot_dt">
                              <p>Regular Time</p>
                              <p>{DataValidationHours.rt}</p>
                              <p>Over Time</p>
                              <p>{DataValidationHours.ot}</p>
                              <p>Drop Time</p>
                              <p>{DataValidationHours.dt}</p>
                            </div>
                            <div style={{ width: "50%", marginLeft: "25%" }}>
                              <Divider type="horizontal" className="divider1" />
                            </div>
                            <div className="week_Biweek_emp">
                              <p>Weekly Employees</p>
                              <p>2500</p>
                              <p>Bi Weekly Employees</p>
                              <p>700</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div className="refresh">
                    <h3 className="timecards-heading">Data Validation</h3>
                    {/* <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "10%",
                        justifyContent: "space-around",
                      }}
                    >
                      <ReloadOutlined
                        className="data-validation-table-icon"
                        onClick={() => dispatch(Get_DV_ConsolidatedReport())}
                      />
                      <FilterOutlined className="data-validation-table-icon" />
                      <FullscreenOutlined className="data-validation-table-icon" />
                    </div> */}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div style={{ width: "100%" }}>
                    <Table></Table>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div className="card">
                    <UploadFile />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div className="card1">
                    <div style={{ width: "50%", display: "flex", justifyContent: "center" }}>
                      <Button
                        className="consolidate-btn"
                        onClick={handleConsolidate}
                        style={{ color: "#002766", fontWeight: "bold" }}
                      >
                        Consolidate Review
                      </Button>
                      <div >
                        {isloadingconsolidate ? loader(isloadingconsolidate) : null}
                      </div>
                    </div>
                    <div style={{ width: "59%", display: "flex", justifyContent: "center",marginTop:"1%" }}>
                      <Button
                        className="review-btn"
                        onClick={handleUnMatchedNames}
                        style={{ color: "#002766", fontWeight: "bold", marginLeft: 10,alignItems:"center" }}
                      >
                        UnmatchedList<DownloadOutlined/>
                      </Button>
                      <div >
                        {isloadingUnmatchedlist ? loader(isloadingUnmatchedlist) : null}
                      </div>
                      <div>
                        <UnmatchedList/>
                      <a href="/masterfile" style={{marginLeft:-170,fontWeight:"bold"}}>Go to Payroll Masterfile </a>
                      </div>

                      {/* <Button
                        className="review-btn"
                        onClick={() => handleReview("weekly")}
                        style={{ color: "#002766", fontWeight: "bold" }}
                      >
                        Weekly Download
                      </Button>
                      <div>
                        {isloading ? loader(isloading) : null}
                      </div> */}
                      {/* <Button
                        className="review-btn"
                        onClick={() => handleReview("biweekly")}
                        style={{ color: "#002766", fontWeight: "bold" }}
                      >
                        Biweekly Download
                      </Button>
                      <div>
                        {biweeklyLoader ? loader(biweeklyLoader) : null}
                      </div> */}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            {
              AutoCrawl.invalidClients.length === 0 && AutoCrawl.failedClients.length === 0 && ReConsolidation_Clients_State.ReConsolidationClients.length === 0 ? null :
                <div style={{ width: "22%", padding: "10px", marginTop: "2%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div style={{ height: "58%", width: "100%" }} className="failed-clients-block">
                    {AutoCrawl.invalidClients.length === 0 ? <div style={{ display: "flex", alignContent: "center" }}>
                      <Empty description={<span style={{ color: "#003A8C" }}>Hurray! All Clients are Updated</span>} /></div> :
                      <InvalidClientsCard />
                    }
                  </div>
                  <div className="failed-clients-sub">
                    <div className="failed-clients-sub-list-header">
                      <Divider style={{ color: "#003A8C" }}>Failed Clients <Tooltip title="Please Upload Manually" color="#1c90e8" ><InfoCircleOutlined className="failed-clients-info" /></Tooltip></Divider>
                    </div>
                    <div className="failed-clients-sub-list">
                      <List size="small" dataSource={AutoCrawl.failedClients} renderItem={(item) => <List.Item>{item}</List.Item>} />
                    </div>
                  </div>
                </div>
            }
          </div>
        </Layout>
      </Layout>
    </div>
  );
};
export default Timecards;
